/* global axios */
import ApiClient from '../ApiClient';

// Biblioteca de templates do Studio (texto). CRUD account-scoped contra
// /api/v1/accounts/:account_id/ai/templates. `variables`/`required_tools`
// são DERIVADOS do body no backend (read-only no front).
class StudioTemplate extends ApiClient {
  constructor() {
    super('ai/templates', { accountScoped: true });
  }

  // O index aceita ?kind= pra filtrar por tipo (presentation|record_picker).
  get({ kind } = {}) {
    return axios.get(this.url, { params: { kind } });
  }
}

export default new StudioTemplate();
